import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { ZuperDialogComponent } from './zuper-dialog.component';
import { ZuperDialogService } from './zuper-dialog.service';

@NgModule({
    declarations: [
        ZuperDialogComponent
    ],
    imports: [
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        CommonModule
    ],
    exports: [
        MatDialogModule
    ],
    providers   : [
        ZuperDialogService,
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { maxWidth: '100vw', hasBackdrop: true } }
    ]
})
export class ZuperDialogModule
{
    /**
     * Constructor
     */
    constructor(private _zuperDialogService: ZuperDialogService)
    {
    }
}
